// import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import HeroEstore from "../components/HeroEstore";
import Productsestore from "../components/Productsestore";
import EstoreWhy from "../components/EstoreWhy";
import EstoreSolutions from "../components/EstoreSolutions";
import EstoreWhy2 from "../components/EstoreWhy2";
import OnlineBenefits from "../components/OnlineBenefits";
import ServiceHighlights from "../components/ServiceHighlights";
import FAQestore from "../components/FAQestore";
import Footer from "../components/Footer";
import ScrollToTopButton from "../components/ScrollToTopButton";
// import AuthPopup from "../components/AuthPopup";

export default function Estore() {
  // const [isAuthenticated, setIsAuthenticated] = useState(false);

  // useEffect(() => {
  //   window.scrollTo(0, 0);
  //   const userId = localStorage.getItem("userId");
  //   if (userId) setIsAuthenticated(true);
  // }, []);

  // const handleAuthSuccess = () => {
  //   setIsAuthenticated(true);
  // };

  return (
    <>
      {/* {!isAuthenticated && <AuthPopup onAuthSuccess={handleAuthSuccess} />}
      {isAuthenticated && ( */}
        {/* <> */}
          <Navbar />
          <HeroEstore />
          <Productsestore />
          <EstoreWhy />
          <EstoreSolutions />
          <EstoreWhy2 />
          <OnlineBenefits />
          <ServiceHighlights />
          <FAQestore />
          <Footer />
          <ScrollToTopButton />
        {/* </> */}
      {/* )} */}
    </>
  );
}
